import { render, staticRenderFns } from "./terms-and-condition.vue?vue&type=template&id=5018828a&"
import script from "./terms-and-condition.vue?vue&type=script&lang=js&"
export * from "./terms-and-condition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports